export default "__VITE_ASSET__Cbafh5xt__"